// Custom theme modifications
document.addEventListener('DOMContentLoaded', function() {
  initProductSwatchPrices();
});

function initProductSwatchPrices() {
  const productCards = document.querySelectorAll('.product-item');
  
  productCards.forEach(card => {
    const priceWrapper = card.querySelector('.product-item__price-wrapper');
    const salePrice = priceWrapper.querySelector('.sale')
    const swatches = card.querySelectorAll('.product-item-options__item--swatch');
    const imageLink = card.querySelector('.product-item__image-link');
    
    if (!priceWrapper || !swatches.length || !imageLink) return;
    
    // Store original price HTML
    const originalPriceHtml = priceWrapper.innerHTML;
    
    // Track if we've initialized the image layer
    let imageLayerInitialized = false;
    let swatchImageLayer, frontImage, backImage, isBackImageActive;
    
    // Function to initialize image layer
    const initializeImageLayer = () => {
      if (imageLayerInitialized) return;
      
      // Add class to disable theme animations only when we start using swatches
      card.classList.add('product-item--has-swatches');
      
      // Create our own image layers for crossfade
      swatchImageLayer = document.createElement('div');
      swatchImageLayer.className = 'swatch-image-layer';
      
      // Create two images for crossfade effect
      frontImage = document.createElement('img');
      frontImage.className = 'swatch-image swatch-image--front';
      
      backImage = document.createElement('img');
      backImage.className = 'swatch-image swatch-image--back';
      
      // Get initial image source and attributes from the first product image
      const firstImage = imageLink.querySelector('img');
      if (firstImage) {
        // Copy all relevant attributes from the original image
        ['src', 'srcset', 'sizes', 'width', 'height', 'loading', 'alt'].forEach(attr => {
          if (firstImage.hasAttribute(attr)) {
            const value = firstImage.getAttribute(attr);
            frontImage.setAttribute(attr, value);
            backImage.setAttribute(attr, value);
          }
        });
      }
      
      swatchImageLayer.appendChild(backImage);
      swatchImageLayer.appendChild(frontImage);
      imageLink.appendChild(swatchImageLayer);
      
      isBackImageActive = false;
      imageLayerInitialized = true;
    };
    
    swatches.forEach(swatch => {
      swatch.addEventListener('mouseenter', () => {
        // Initialize image layer on first hover if needed
        if (!imageLayerInitialized) {
          initializeImageLayer();
        }
        
        // Update price and links
        const variantPrice = swatch.getAttribute('data-variant-price');
        const variantUrl = swatch.getAttribute('href');
        
      if (variantPrice) {
        const productItemSale = card.querySelector('.product-item__price-wrapper .sale');
        const salePrice = card.querySelector('.sale'); // <-- ensure correct selector
        
        if (salePrice) {
          const priceEl = productItemSale || card.querySelector('.product-item__price');
          if (priceEl) {
            const word = priceEl.innerText.split('$');
            salePrice.innerHTML = `${word.length > 1 ? word[0] : ''} ${variantPrice}`;
          } else {
            console.warn('No price element found in card:', card);
          }
        } else {
          console.warn('No .sale-price element found in card:', card);
        }
      }
        
        // Update all product links to point to current variant
        if (variantUrl) {
          // Update main image link
          imageLink.href = variantUrl;
          
          // Update product title link
          const titleLink = card.querySelector('.product-item__product-title a');
          if (titleLink) {
            titleLink.href = variantUrl;
          }
        }
        
        // Update image with crossfade
        const imageUrl = swatch.getAttribute('data-variant-image-url');
        if (imageUrl && imageLayerInitialized) {
          const currentImage = isBackImageActive ? backImage : frontImage;
          const newImage = isBackImageActive ? frontImage : backImage;
          
          // Prepare new image
          newImage.style.opacity = '0';
          
          // Update srcset and sizes if they exist in the original image
          const firstImage = imageLink.querySelector('img');
          if (firstImage && firstImage.hasAttribute('srcset')) {
            const originalSrcset = firstImage.getAttribute('srcset');
            const newSrcset = originalSrcset.replace(/(^|\s)\/\/[^\s]*/g, '$1' + imageUrl);
            newImage.setAttribute('srcset', newSrcset);
          } else {
            newImage.removeAttribute('srcset');
          }
          
          newImage.src = imageUrl;
          
          // Force browser to recognize the new image
          void newImage.offsetWidth;
          
          // Fade in new image
          newImage.style.opacity = '1';
          
          // Fade out current image
          currentImage.style.opacity = '0';
          
          // Toggle which image is active
          isBackImageActive = !isBackImageActive;
        }
        
        // Update active state
        swatches.forEach(s => s.classList.remove('is-active'));
        swatch.classList.add('is-active');
      });
      
      // Handle click for navigation
      swatch.addEventListener('click', (e) => {
        e.preventDefault();
        const variantUrl = swatch.getAttribute('href');
        if (variantUrl) {
          window.location.href = variantUrl;
        }
      });
    });
  });
}
